import netflix from "./images/optimized-images/netflix_react-min.PNG";
import room from "./images/optimized-images/room_frontend-min.PNG";
import guessWords from "./images/optimized-images/guessWords_javascript-min.PNG";
import hbd from "./images//optimized-images/hbd_javascript-min.PNG";
import headphones from "./images/optimized-images/headphones_frontend-min.PNG";
import nov from "./images/optimized-images/nov_frontend-min.PNG";
import pigGame from "./images/optimized-images/pigGame_javascript-min.PNG";
import store from "./images/optimized-images/store_frontend-min.PNG";
import cms from "./images/optimized-images/cms_php-min.PNG";
import tessitura from "./images/optimized-images/tessitura_php-min.PNG";
import sunnyside from "./images/optimized-images/sunnyside_frontend-min.PNG";
import githubApi from "./images/optimized-images/githubApi_react-min.PNG";
import reactWebsite from "./images/optimized-images/reactWebsiteTemplate_react-min.PNG";
import covidAPI from "./images/optimized-images/covid19API_javascript-min.PNG";
import ajaxFilter from "./images/optimized-images/ajaxFilter_php-min.PNG";
import domManipulation from "./images/optimized-images/DOM_manipulation_javascript-min.PNG";
import notes from "./images/optimized-images/notes_app_javascript-min.PNG";
import ajaxForm from "./images/optimized-images/ajax_form_php-min.PNG";
import restaurant from "./images/optimized-images/restaurant-min.PNG";
import calorie from "./images/optimized-images/calorie-min.PNG";
import todo from "./images/optimized-images/todo-app-min.PNG";
import bookstore from "./images/optimized-images/book-store-min.PNG";
import stopwatch from "./images/optimized-images/stopwatch-min.PNG";
import nurtureTemplate from "./images/optimized-images/nurture-template-min.PNG";
import scoresightTemplate from "./images/optimized-images/scoresight-min.PNG";
import reduxShop from "./images/optimized-images/redux-shop-min.PNG";

const ProjectApi = [
  {
    id: 1,
    image: room,
    name: "Room Landing Page ",
    category: "frontend",
    link: "https://faiz-9.github.io/faizan-room-homepage/",
  },

  {
    id: 2,
    image: sunnyside,
    name: "Sunnyside Template",
    category: "frontend",
    link: "https://faiz-9.github.io/sunnyside_landing_page/",
  },

  {
    id: 3,
    image: cms,
    name: "Content Management System",
    category: "php",
    link: "http://cmsfaizan.infinityfreeapp.com/CMS_TEMPLATE/",
  },

  {
    id: 4,
    image: netflix,
    name: "Netflix Clone",
    category: "react",
    link: "https://faiz-9.github.io/netflix-clone/",
  },

  {
    id: 5,
    image: guessWords,
    name: "Harry Potter Quiz",
    category: "javascript",
    link: "https://faiz-9.github.io/HarryPotterQuiz.github.io/",
  },

  {
    id: 6,
    image: hbd,
    name: "Birdthay Celebration",
    category: "javascript",
    link: "https://faiz-9.github.io/happyBirthday.github.io/",
  },

  {
    id: 7,
    image: headphones,
    name: "Headphones Template",
    category: "frontend",
    link: "https://faiz-9.github.io/headphones.github.io/",
  },

  {
    id: 8,
    image: nov,
    name: "Megascopic Landing Page",
    category: "frontend",
    link: "https://faiz-9.github.io/faiz_nov.github.io/",
  },

  {
    id: 9,
    image: pigGame,
    name: "Pig Game",
    category: "javascript",
    link: "https://faiz-9.github.io/pigGame-github.io/",
  },

  {
    id: 10,
    image: store,
    name: "Store Template",
    category: "frontend",
    link: "https://faiz-9.github.io/faizan-store.github.io/",
  },

  {
    id: 11,
    image: tessitura,
    name: "Freelancing Project",
    category: "php",
    link: "https://tessituraparklane.com/",
  },

  {
    id: 12,
    image: githubApi,
    name: "GitHub Users Using API",
    category: "react",
    link: "https://faiz-9.github.io/github_api/",
  },

  {
    id: 13,
    image: reactWebsite,
    name: "React Website Template",
    category: "react",
    link: "https://faiz-9.github.io/react-app-faiz/",
  },

  {
    id: 14,
    image: covidAPI,
    name: "Covid State Wise Status ",
    category: "javascript",
    link: "https://faiz-9.github.io/covid_india_by_faizan.github.io/",
  },

  {
    id: 15,
    image: ajaxFilter,
    name: "Ajax Live Filter Php ",
    category: "php",
    link: "http://ajax-filter-faizan.infinityfreeapp.com/advance-ajax-php-product-search-filter/",
  },

  {
    id: 16,
    image: notes,
    name: "Notes App",
    category: "javascript",
    link: "https://faiz-9.github.io/notes_app/",
  },

  {
    id: 17,
    image: domManipulation,
    name: "JS DOM Project",
    category: "javascript",
    link: "https://faiz-9.github.io/dom_project/",
  },

  {
    id: 18,
    image: ajaxForm,
    name: "Php Ajax Form",
    category: "php",
    link: "http://ajax-form.infinityfreeapp.com/AJAX_DATABASE_PROJECT1/",
  },

  {
    id: 19,
    image: restaurant,
    name: "Restaurant Review System",
    category: "full-stack",
    link: "https://restaurant-review-system-faizan.netlify.app/",
  },

  {
    id: 20,
    image: calorie,
    name: "Calorie Tracker",
    category: "react",
    link: "https://calorie-tracker-faizan.netlify.app/",
  },

  {
    id: 21,
    image: todo,
    name: "Todo List React",
    category: "react",
    link: "https://faizan-todo-list-react.netlify.app/",
  },

  {
    id: 22,
    image: bookstore,
    name: "Book Store App",
    category: "react",
    link: "https://react-book-store-app-faizan.netlify.app/",
  },

  {
    id: 23,
    image: stopwatch,
    name: "React Redux Stopwatch",
    category: "react",
    link: "https://stopwatch-redux-faizan.netlify.app/",
  },

  {
    id: 24,
    image: nurtureTemplate,
    name: "CSS Template with Next Js",
    category: "frontend",
    link: "https://nurturelabs-bs5id29df-faiz-9.vercel.app/",
  },

  {
    id: 25,
    image: scoresightTemplate,
    name: "CSS Template",
    category: "frontend",
    link: "https://faizan-final-html-css-test.netlify.app/",
  },

  {
    id: 26,
    image: reduxShop,
    name: "React Redux Shopping App",
    category: "react",
    link: "https://redux-store-faizan.netlify.app/",
  },
];

export default ProjectApi;
